import React from 'react';
import { ArrowLeft } from 'lucide-react';
import Breadcrumb from '../breadcrumb';

interface ReportHeaderProps {
  title: string;
  onBack: () => void;
}

const ReportHeader: React.FC<ReportHeaderProps> = ({ title, onBack }) => {
  return (
    <div className="flex items-center">
      <ArrowLeft
        id="back-button"
        className="text-gray-600 mr-2 w-5 h-5 cursor-pointer"
        onClick={onBack}
      />
      <Breadcrumb title={title} />
    </div>
  );
};

export default ReportHeader;
